module.exports = __webpack_public_path__ + "static/img/desplazamientos-2.ce0c2c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/desplazamientos-2.jpg
// module id = YgDG
// module chunks = 1